import { createTheme } from "@material-ui/core/styles";
import { lightBlue } from "@material-ui/core/colors"; // lime

export const themeLight = createTheme({
  palette: {
    primary: {
      main: "#3aa2cc"
    },
    secondary: lightBlue,
    // primary:  lime,
    // secondary: lightBlue,
    type: "light"
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#424242",
        color: "#3aa2cc" // lime["500"]
      }
    },
    MuiTypography: {
      h1: {
        marginBottom: 16
      },
      h2: {
        marginBottom: 16
      },
      h3: {
        marginBottom: 16
      },
      h4: {
        marginBottom: 16
      },
      h5: {
        marginBottom: 16
      },
      h6: {}
    }
  }
});
